export default __webpack_public_path__ + "static/media/slide2-b.06e05fa6.jpg";